import React from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import { useRouter } from "next/router";
import * as config from '../../../next.config.js'
import Image from 'next/image'
function EntityAddress({ entityId ,callback,address}) {
    const { locale } = useRouter();
    const { t } = useTranslation("common")
    const [medicalCardAbout, setMMedicalCardAbout] = React.useState([])
    React.useEffect(() => {
            if (entityId&&address&&address.length>0) {
                    setMMedicalCardAbout(...address)
          

            }

    }, [])
    return (
        <>
            {
                medicalCardAbout&&medicalCardAbout.length>0 ?
                    <>
                        <div className={style.SectionContainer}>
                            <div className={style.allcard}>

                                <div className={style.TitleandIcons} >
                                    <div className={style.icontitle} > <Image className={style.icontitle} src={`${config.basePath}/assest/Artboard–1.png`} width={100} height={100} alt={"hakeem"}/></div>
                                    <div className={style.hLine9 + " " + style.paddingZero} >{t("ttlAddress")} </div>
                                </div>
                                {
                                    medicalCardAbout.filter(ele=>ele.permanent).map((aboutItem,key) => {
                                        return (
                                          
                                                <div className={style.paragraphandIconsSpecialty} key={key}>
                                                        <div className={style.Circle} > </div>
                                                    {/* <div className={style.viewmedical}> <Image  className={style.viewmedical}  src={`${config.basePath}/assest/BackGroundOfferheader.svg`}   width={100} height={100} alt={"hakeem"}/></div> */}
                                                    {/* <p className={style.aboutText} dangerouslySetInnerHTML={{__html: aboutItem.transBlog[0].body}}>
                                                      

                                                    </p> */}
                                                 
                                                    <p className={style.aboutText + " " + style.marginZero}>{ aboutItem.country && aboutItem.country.length>0?aboutItem.country.filter(ele=>ele.language.code==locale).length>0?aboutItem.country.filter(ele=>ele.language.code==locale)[0].name:aboutItem.country[0].name:""}
                                                    {" "}
                                                    { aboutItem.city &&aboutItem.city.length>0?aboutItem.city.filter(ele=>ele.language.code==locale).length>0?aboutItem.city.filter(ele=>ele.language.code==locale)[0].name:aboutItem.city[0].name:""}
                                                    {" "}
                                                    { aboutItem.district &&aboutItem.district.length>0?aboutItem.district.filter(ele=>ele.language.code==locale).length>0?aboutItem.district.filter(ele=>ele.language.code==locale)[0].name:aboutItem.district[0].name:""}
                                                    {" "}
                                                    {aboutItem.physicalAddress}
                                                    </p>
                                                    <br />
                                                </div>
                                         
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </>
                    : ""
            }
        </>

    )
}

export default EntityAddress
